export default __webpack_public_path__ + "static/media/tissueGW.caef97e8.png";